import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {  SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'library-conditions',
  templateUrl: './library-conditions.component.html',
  styleUrls: ['./library-conditions.component.less']
})
export class LibraryConditionsComponent implements OnInit, OnDestroy{

  libraryConditions:SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService
  ) {
  }


  ngOnInit() {

    this.informationService.getFrontParams().pipe(
      takeUntil(this.destroySubject),
    )
      .subscribe(
      (res: any) => {
        let libraryConditionsHtml = res.results.find ((value:any) =>  value.name == 'library-conditions')?.value;
        this.libraryConditions = this.informationService.getSanitizeString(libraryConditionsHtml);

    })

  }

  ngOnDestroy() {
    this.destroySubject.next();
  }

}




